// import {throttle} from 'throttle-debounce';
class HeaderManager {
    constructor() {
        this.header = document.querySelector('.j-header');
        this.wrapper = document.querySelector('.j-wrapper');
        this.headerHeight = this.header?.offsetHeight;
        this.isCurrentPageComfort = window.location.pathname.includes('about-comfort');

        this.init();
    }

    init() {
        if (!this.wrapper) {
            return;
        }
        if (!this.header) {
            return;
        }

        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
        const isMoreDelta = window.scrollY > 60;
        const headerModifyMethod = isMoreDelta ? 'add' : 'remove';
        const wrapperPadding = isMoreDelta ? `${this.headerHeight}px` : '0';

        this.header.classList[headerModifyMethod]('header_theme_white', 'is-scroll');

        if (!this.header.classList.contains('header_position_absolute')) {
            this.wrapper.style.paddingTop = wrapperPadding;
        }

        if (this.isCurrentPageComfort) {
            this.header.classList[headerModifyMethod]('header_theme_comfort-white');
        }
    }
}

const headerManager = new HeaderManager();

export {headerManager};
